import React from "react";
import { FiMapPin, FiPhone, FiMail, FiSend } from "react-icons/fi";
import SocialWidget from "../components/floatingwidget";

const HeadOffice = [
  {
    title: "Head Office",
    address: "No 5 Akpakpava Road, Benin City, Edo State.",
    phone: "07000002332",
    email: "customercomplaints@beninelectric.com",
  }
];

const offices = [
  {
    title: "Warri Regional Office",
    address: "25, Warri-Sapele Road, Opposite Warri Boatyard, NPA, Warri, Delta State.",
    phone: "08027900218",
  },
  {
    title: "Ondo Regional Office",
    address: "Adefe House, Ago-Itunu Road, Ondo State.",
    phone: "08027784257",
  },
  {
    title: "Ekiti Regional Office",
    address: "55, Ikere Road, Ado Ekiti, Ekiti State.",
    phone: "09015960557",
  },
  {
    title: "Asaba Regional Office",
    address: "Block 11B, Anwai Road, Phase I, Asaba Core Area, Delta State.",
    phone: "08027725679",
  },
  {
    title: "Sapele Regional Office",
    address: "Block AT&P Yard, Along Sapele-Warri Road, Amuogodo, Sapele, Delta State.",
    phone: "08027725435",
  },
  {
    title: "Auchi Regional Office",
    address: "No 119, Auchi- Jatti Road, Auchi, Edo State.",
    phone: "08027725226",
  },
  {
    title: "Akure Regional Office",
    address: "No. 1 Adekunle Ajasin Road, Nepa Roundabout, Akure, Ondo State.",
    phone: "08027784224",
  },
  {
    title: "Benin-North Regional Office",
    address: "46, Textile Mill Road, Benin City, Edo State.",
    phone: "08027783512",
  },
  {
    title: "Benin-South Regional Office",
    address: "14, Omoragbon-Agho Street, Off Sapele Road, Benin-City, Edo State.",
    phone: "09019597808",
  },
];

export default function Contact() {
  return (
    <div className="bg-white min-h-screen font-sans">
      {/* Hero & Contact Section */}
      <section className="relative py-12 md:py-16 overflow-hidden bg-white">
        <div className="max-w-7xl container mx-auto px-4 md:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">

            {/* Left Side: Content */}
            <div className="w-full lg:w-1/2">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-1 bg-yellow-400 rounded-full"></div>
                <span className="text-xs font-bold text-green-700 uppercase tracking-widest">
                  Contact Us
                </span>
              </div>
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-black mb-4 md:mb-6 leading-tight uppercase tracking-tight">
                Let’s start a <span className="text-green-700 block">conversation.</span>
              </h1>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-6 md:mb-8 leading-relaxed font-normal">
                We are here because of you. If you have any concerns or feedback,
                please reach out. Our team usually responds within 24 hours.
              </p>

              <div className="space-y-6 mb-8">
                <div className="flex items-center gap-4 group">
                  <div className="w-12 h-12 bg-yellow-400 rounded-xl flex items-center justify-center text-black shadow-md group-hover:bg-black group-hover:text-yellow-400 transition-colors flex-shrink-0">
                    <FiPhone size={20} />
                  </div>
                  <div>
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Call us</p>
                    <p className="text-lg md:text-xl font-bold text-black">0700 000 2332</p>
                  </div>
                </div>

                <div className="flex items-center gap-4 group">
                  <div className="w-12 h-12 bg-green-700 rounded-xl flex items-center justify-center text-white shadow-md group-hover:bg-yellow-400 group-hover:text-black transition-colors flex-shrink-0">
                    <FiMail size={20} />
                  </div>
                  <div className="min-w-0">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Email us</p>
                    <p className="text-sm md:text-base font-bold text-black break-all">
                      info@beninelectric.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: PDF Object Wrapper */}
            <div className="w-full lg:w-1/2 relative">
              <div className="absolute -top-10 -right-10 w-48 h-48 bg-yellow-100 rounded-full blur-3xl opacity-60"></div>
              <div className="absolute -bottom-10 -left-10 w-48 h-48 bg-green-100 rounded-full blur-3xl opacity-60"></div>
              <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border-4 md:border-8 border-white ring-1 ring-gray-100">
                <object 
                  width="100%" 
                  data="/file/BEDC RAPID RESPONSE NUMBERS 2025.pdf" 
                  type="application/pdf" 
                  className="w-full h-[350px] md:h-[500px]"
                >
                  <div className="p-10 text-center bg-gray-50">
                    <p className="text-base font-bold">PDF viewing not supported by your browser.</p>
                  </div>
                </object>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Banner Section */}
      <section className="w-full">
        <div className="mb-4">
          <img
            src="/images/whistleblowerbanner.png"
            alt="Whistleblower Banner"
            className="w-full h-auto object-cover"
          />
        </div>
      </section>

      {/* Head Office Section */}
      <section className="py-10 md:py-10 bg-gradient-to-br from-green-700 via-green-800 to-black text-white relative overflow-hidden">
        <div className="absolute top-0 right-0 w-72 h-72 bg-yellow-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-white/5 rounded-full blur-3xl"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-16">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-yellow-400 text-black font-bold uppercase tracking-wider text-xs mb-4">
              Corporate Headquarters
            </span>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold uppercase tracking-tight mb-4">
              BEDC Head <span className="text-yellow-400">Office</span>
            </h2>

            <p className="text-sm sm:text-base text-green-100 max-w-3xl mx-auto font-normal">
              Visit our corporate headquarters for enquiries, customer support,
              corporate services and administrative matters.
            </p>
          </div>

          {HeadOffice.map((office, index) => (
            <div
              key={index}
              className="bg-white text-gray-900 rounded-2xl md:rounded-3xl overflow-hidden shadow-xl"
            >
              <div className="grid lg:grid-cols-2">

                {/* Left */}
                <div className="bg-gradient-to-br from-green-700 to-green-900 p-6 md:p-8 text-white flex flex-col justify-center">
                  <div className="w-14 h-14 rounded-2xl bg-yellow-400 text-black flex items-center justify-center mb-6">
                    <FiMapPin size={26} />
                  </div>

                  <h3 className="text-xl md:text-2xl font-bold mb-4 uppercase">
                    {office.title}
                  </h3>

                  <p className="text-sm sm:text-base text-green-100 leading-relaxed font-normal">
                    {office.address}
                  </p>
                </div>

                {/* Right */}
                <div className="p-6 md:p-8">

                  <h4 className="text-xl font-bold text-black mb-6">
                    Contact Information
                  </h4>

                  <div className="space-y-6">

                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl bg-yellow-100 flex items-center justify-center text-yellow-600 flex-shrink-0">
                        <FiPhone size={20} />
                      </div>

                      <div>
                        <p className="text-[10px] uppercase tracking-widest text-gray-400 font-bold">
                          Phone Number
                        </p>

                        <a
                          href={`tel:${office.phone}`}
                          className="text-lg md:text-xl font-bold hover:text-green-700 transition-colors"
                        >
                          {office.phone}
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl bg-green-100 flex items-center justify-center text-green-700 flex-shrink-0">
                        <FiMail size={20} />
                      </div>

                      <div className="min-w-0">
                        <p className="text-[10px] uppercase tracking-widest text-gray-400 font-bold">
                          Email Address
                        </p>

                        <a
                          href={`mailto:${office.email}`}
                          className="text-sm sm:text-base font-bold break-all hover:text-green-700 transition-colors"
                        >
                          {office.email}
                        </a>
                      </div>
                    </div>

                    <div className="pt-4">
                      <a
                        href="https://crm.beninelectric.com/complaints"
                        className="inline-flex items-center gap-2 bg-green-700 hover:bg-black text-white px-6 py-3.5 rounded-xl font-bold uppercase text-xs tracking-wider transition-all duration-300 hover:-translate-y-0.5"
                      >
                        <FiSend />
                        Contact Head Office
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Locations Section with Integrated Icons */}
      <section className="py-10 md:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-black mb-3 uppercase tracking-tight">
              Our Regional <span className="text-green-700">Offices</span>
            </h2>
            <div className="w-20 h-1.5 bg-yellow-400 mx-auto rounded-full mb-4"></div>
            <p className="text-sm sm:text-base text-gray-500 font-normal">Find the nearest BEDC office to your location</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {offices.map((office, index) => (
              <div
                key={index}
                className="group bg-white p-6 md:p-8 rounded-2xl border border-transparent shadow-sm hover:shadow-xl hover:border-green-700/10 transition-all duration-300 relative overflow-hidden flex flex-col justify-between"
              >
                <div className="absolute top-0 left-0 w-1.5 h-0 bg-yellow-400 group-hover:h-full transition-all duration-300"></div>

                <div>
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-green-50 text-green-700 rounded-xl flex items-center justify-center mb-4 border border-green-100 group-hover:bg-green-700 group-hover:text-white transition-colors duration-300">
                    <FiMapPin size={20} />
                  </div>

                  <h3 className="text-lg font-bold text-black mb-3 uppercase tracking-tight">{office.title}</h3>
                  
                  {/* Address with MapPin Icon */}
                  <div className="flex items-start gap-2.5 mb-3 text-gray-600 text-xs sm:text-sm leading-relaxed font-normal">
                    <FiMapPin size={16} className="text-green-700 mt-0.5 flex-shrink-0" />
                    <span>{office.address}</span>
                  </div>
                </div>

                {/* Phone number with Phone Icon and Clickable link */}
                <div className="pt-4 border-t border-gray-100 mt-2">
                  <a
                    href={`tel:${office.phone}`}
                    className="inline-flex items-center gap-2.5 text-xs sm:text-sm font-bold text-black hover:text-green-700 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-lg bg-yellow-100 text-yellow-700 flex items-center justify-center flex-shrink-0">
                      <FiPhone size={14} />
                    </div>
                    <span>{office.phone}</span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quick Complaint Banner Section */}
      <section className="py-12 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-16 text-center flex flex-col items-center">
          <p className="text-sm md:text-base font-medium text-gray-600 mb-4">
            Have a complaint? Click on the link below to get direct assistance.
          </p>
          <a href="https://crm.beninelectric.com/complaints" className="inline-block">
            <button
              type="button"
              className="w-full sm:w-max px-8 py-3.5 bg-black text-white font-bold rounded-xl hover:bg-green-700 transition-all duration-300 flex items-center justify-center gap-2 text-xs uppercase tracking-wider shadow-lg hover:-translate-y-0.5"
            >
              <FiSend size={16} /> Send Quick Message
            </button>
          </a>
        </div>
      </section>

      <SocialWidget />
    </div>
  );
}